import {Component, Inject} from "@angular/core";
import {MAT_SNACK_BAR_DATA} from "@angular/material";
/**
 * Created by greg on 15/03/2018.
 */
@Component({
    selector: 'iconed-snack-bar-component',
    template: `<div><span ngif="data.before_icon" class="material-icons mr-4 {{data.before_class}}">{{data.before_icon}}</span>{{data.msg}}<span ngif="data.after_icon" class="material-icons ml-4 {{data.after_class}}">{{data.after_icon}}</span></div>`,
    styles: [``],
})
export class IconedSnackBar {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any){ }
}


// WEBPACK FOOTER //
// ./src/app/pages/checkit-dashboard/components/snackbars.ts